// Richtung eines Maßes: + (vergrößert das Schließmaß), 0 (deaktiviert,
// nicht berechnet, C5), − (verkleinert). Die Richtung bleibt bei 0
// erhalten; ein Klick auf + oder − aktiviert mit dieser Richtung.
// Tastatur auf der Gruppe: + / 0 / -.

const STUFEN = [
  { key: 'plus', label: '+', title: 'Vergrößert das Schließmaß' },
  { key: 'null', label: '0', title: 'Nicht berechnet (deaktiviert)' },
  { key: 'minus', label: '−', title: 'Verkleinert das Schließmaß' }
];

export default function DirToggle({ direction, inactive = false, onChange }) {
  const dir = direction === -1 ? -1 : 1;
  const aktiv = inactive ? 'null' : dir === 1 ? 'plus' : 'minus';
  const waehle = (key) => {
    if (key === 'null') onChange({ direction: dir, inactive: true });
    else onChange({ direction: key === 'plus' ? 1 : -1, inactive: false });
  };
  const handleKey = (e) => {
    const key = e.key === '+' ? 'plus' : e.key === '0' ? 'null' : (e.key === '-' || e.key === '−') ? 'minus' : null;
    if (!key) return;
    e.preventDefault();
    waehle(key);
  };
  const farbe = { plus: 'var(--color-ok)', null: 'var(--color-ink-3)', minus: 'var(--color-err)' };

  return (
    <div
      role="group"
      aria-label="Wirkrichtung"
      onKeyDown={handleKey}
      className="bg-page border border-line"
      style={{ display: 'inline-flex', height: 26, padding: 2, borderRadius: 6, gap: 1 }}
    >
      {STUFEN.map((s) => {
        const gedrueckt = aktiv === s.key;
        return (
          <button
            key={s.key}
            type="button"
            title={s.title}
            aria-pressed={gedrueckt}
            onClick={() => waehle(s.key)}
            style={{
              width: 22, height: '100%', border: 'none', borderRadius: 4, cursor: 'pointer',
              fontWeight: 700, fontSize: 13,
              color: gedrueckt ? farbe[s.key] : 'var(--color-ink-4)',
              background: gedrueckt
                ? `color-mix(in srgb, ${farbe[s.key]} 16%, var(--color-surface))`
                : 'transparent'
            }}
          >
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
